import 'react-datepicker/dist/react-datepicker.css';
import 'react-pro-sidebar/dist/css/styles.css';

import { ThemeProvider } from '../ThemeContext';
import { UIProviderProps } from './UIProvider.types';
import { ProgressNotifierProvider } from '../ProgressNotifierContext';
import { UIContext } from './UIContext';

export const UIProviders = ({ children, appVariant }: UIProviderProps) => {
  return (
    <UIContext.Provider value={{ appVariant }}>
      <ThemeProvider>
        <ProgressNotifierProvider>{children}</ProgressNotifierProvider>
      </ThemeProvider>
    </UIContext.Provider>
  );
};
